module.exports = __webpack_public_path__ + "static/media/phone-lg-full.03f7484e.png";